import React, { useState, useEffect } from 'react';
import API from '../../utils/api';

const days = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

const timeSlots = [];
for (let h = 6; h <= 20; h++) {
  timeSlots.push(`${String(h).padStart(2,'0')}:00`);
  if (h < 20) timeSlots.push(`${String(h).padStart(2,'0')}:30`);
}

const MemberClassSchedule = () => {
  const [schedules, setSchedules] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [newSchedule, setNewSchedule] = useState({
    subject: '', day: 'Monday',
    start_time: '08:00', end_time: '09:30'
  });
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [activeDay, setActiveDay] = useState('Monday');

  useEffect(() => { fetchSchedules(); }, []);

  const showMsg = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => setMessage(''), 3000);
  };

  const fetchSchedules = async () => {
    try {
      const res = await API.get('/schedules/mine');
      setSchedules(res.data);
    } catch (error) { console.error(error); }
  };

  const handleAdd = async () => {
    if (!newSchedule.subject || !newSchedule.day ||
      !newSchedule.start_time || !newSchedule.end_time) {
      showMsg('Please fill in all fields!', 'error');
      return;
    }
    if (newSchedule.start_time >= newSchedule.end_time) {
      showMsg('End time must be after start time!', 'error');
      return;
    }
    try {
      await API.post('/schedules', newSchedule);
      showMsg('✅ Schedule added!', 'success');
      setShowAdd(false);
      setNewSchedule({
        subject: '', day: 'Monday',
        start_time: '08:00', end_time: '09:30'
      });
      fetchSchedules();
    } catch (error) {
      showMsg('Error adding schedule!', 'error');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this schedule?')) return;
    try {
      await API.delete(`/schedules/${id}`);
      showMsg('✅ Schedule deleted!', 'success');
      fetchSchedules();
    } catch (error) {
      showMsg('Error!', 'error');
    }
  };

  const daySchedules = schedules.filter(s => s.day === activeDay);

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>📅 My Class Schedule</h2>
          <p style={styles.subtitle}>Manage your weekly class schedule</p>
        </div>
        <button style={styles.addBtn} onClick={() => setShowAdd(true)}>
          + Add Schedule
        </button>
      </div>

      {/* Message */}
      {message && (
        <div style={messageType === 'success' ?
          styles.successMsg : styles.errorMsg}>
          {message}
        </div>
      )}

      {/* Day Selector */}
      <div style={styles.daySelector}>
        {days.map(day => (
          <button
            key={day}
            style={activeDay === day ? styles.dayActive : styles.dayBtn}
            onClick={() => setActiveDay(day)}
          >
            {day.slice(0, 3)}
          </button>
        ))}
      </div>

      {/* Schedule List */}
      <div style={styles.scheduleBox}>
        <h3 style={styles.dayTitle}>{activeDay}</h3>
        {daySchedules.length === 0 ? (
          <div style={styles.emptyState}>
            <p style={styles.emptyIcon}>📅</p>
            <p style={styles.emptyText}>No classes on {activeDay}!</p>
            <button style={styles.addBtnSmall}
              onClick={() => {
                setNewSchedule({ ...newSchedule, day: activeDay });
                setShowAdd(true);
              }}>
              + Add class
            </button>
          </div>
        ) : (
          <div style={styles.timelineBox}>
            {daySchedules
              .sort((a, b) => a.start_time.localeCompare(b.start_time))
              .map(s => (
                <div key={s.id} style={styles.scheduleItem}>
                  <div style={styles.timeBox}>
                    <p style={styles.startTime}>
                      {s.start_time.slice(0, 5)}
                    </p>
                    <div style={styles.timeLine} />
                    <p style={styles.endTime}>
                      {s.end_time.slice(0, 5)}
                    </p>
                  </div>
                  <div style={styles.subjectBox}>
                    <p style={styles.subjectName}>{s.subject}</p>
                    <p style={styles.subjectTime}>
                      {s.start_time.slice(0, 5)} — {s.end_time.slice(0, 5)}
                    </p>
                  </div>
                  <button style={styles.deleteBtn}
                    onClick={() => handleDelete(s.id)}>
                    🗑️
                  </button>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* Weekly Overview */}
      <div style={styles.weeklyBox}>
        <h3 style={styles.weeklyTitle}>📊 Weekly Overview</h3>
        <div style={styles.weeklyGrid}>
          {days.map(day => {
            const dayCount = schedules.filter(s => s.day === day).length;
            return (
              <div key={day} style={styles.weeklyItem}
                onClick={() => setActiveDay(day)}>
                <p style={styles.weeklyDay}>{day.slice(0, 3)}</p>
                <div style={{
                  ...styles.weeklyBar,
                  height: `${Math.max(dayCount * 20, 4)}px`,
                  background: dayCount > 0 ? '#0f3460' : '#eee',
                }} />
                <p style={styles.weeklyCount}>
                  {dayCount > 0 ? dayCount : '—'}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Add Schedule Modal */}
      {showAdd && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>📅 Add Class Schedule</h3>
            <div style={styles.field}>
              <label style={styles.label}>Subject *</label>
              <input style={styles.input} type="text"
                placeholder="ex. ARTAPP, PE, Math"
                value={newSchedule.subject}
                onChange={e => setNewSchedule({
                  ...newSchedule, subject: e.target.value
                })} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Day *</label>
              <select style={styles.input}
                value={newSchedule.day}
                onChange={e => setNewSchedule({
                  ...newSchedule, day: e.target.value
                })}>
                {days.map(d => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </select>
            </div>
            <div style={styles.timeRow}>
              <div style={styles.field}>
                <label style={styles.label}>Start Time *</label>
                <select style={styles.input}
                  value={newSchedule.start_time}
                  onChange={e => setNewSchedule({
                    ...newSchedule, start_time: e.target.value
                  })}>
                  {timeSlots.map(t => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>
              <div style={styles.field}>
                <label style={styles.label}>End Time *</label>
                <select style={styles.input}
                  value={newSchedule.end_time}
                  onChange={e => setNewSchedule({
                    ...newSchedule, end_time: e.target.value
                  })}>
                  {timeSlots.map(t => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>
            </div>
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn}
                onClick={() => setShowAdd(false)}>
                Cancel
              </button>
              <button style={styles.doneBtn} onClick={handleAdd}>
                Add Schedule
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: { padding: '0' },
  header: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'flex-start', marginBottom: '20px',
    flexWrap: 'wrap', gap: '10px',
  },
  title: { margin: '0 0 5px 0', fontSize: '22px', color: '#333' },
  subtitle: { margin: 0, color: '#888', fontSize: '13px' },
  addBtn: {
    padding: '10px 18px',
    background: 'linear-gradient(135deg, #0f3460, #16213e)',
    color: 'white', border: 'none', borderRadius: '10px',
    cursor: 'pointer', fontWeight: 'bold', fontSize: '13px',
  },
  successMsg: {
    background: '#e0ffe0', color: '#006600',
    padding: '12px', borderRadius: '8px',
    marginBottom: '15px', fontSize: '14px',
  },
  errorMsg: {
    background: '#ffe0e0', color: '#cc0000',
    padding: '12px', borderRadius: '8px',
    marginBottom: '15px', fontSize: '14px',
  },
  daySelector: {
    display: 'flex', gap: '8px',
    marginBottom: '20px', flexWrap: 'wrap',
  },
  dayBtn: {
    padding: '8px 16px', background: 'white',
    border: '1.5px solid #ddd', borderRadius: '20px',
    cursor: 'pointer', fontSize: '13px', color: '#666',
  },
  dayActive: {
    padding: '8px 16px', background: '#0f3460',
    border: '1.5px solid #0f3460', borderRadius: '20px',
    cursor: 'pointer', fontSize: '13px',
    color: 'white', fontWeight: 'bold',
  },
  scheduleBox: {
    background: 'white', borderRadius: '16px',
    padding: '20px', marginBottom: '20px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
  },
  dayTitle: {
    margin: '0 0 15px 0', fontSize: '16px',
    fontWeight: 'bold', color: '#333',
  },
  emptyState: { textAlign: 'center', padding: '30px 0' },
  emptyIcon: { fontSize: '40px', margin: '0 0 10px 0' },
  emptyText: { color: '#888', fontSize: '14px', margin: '0 0 15px 0' },
  addBtnSmall: {
    padding: '8px 16px', background: '#0f3460',
    color: 'white', border: 'none', borderRadius: '8px',
    cursor: 'pointer', fontSize: '13px', fontWeight: 'bold',
  },
  timelineBox: { display: 'flex', flexDirection: 'column', gap: '10px' },
  scheduleItem: {
    display: 'flex', alignItems: 'center',
    gap: '15px', padding: '15px',
    background: '#f8f9fa', borderRadius: '12px',
  },
  timeBox: {
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', minWidth: '50px',
  },
  startTime: {
    margin: 0, fontSize: '12px',
    fontWeight: 'bold', color: '#0f3460',
  },
  timeLine: {
    width: '2px', height: '20px',
    background: '#ddd', margin: '3px 0',
  },
  endTime: { margin: 0, fontSize: '12px', color: '#888' },
  subjectBox: { flex: 1 },
  subjectName: {
    margin: '0 0 3px 0', fontWeight: 'bold',
    color: '#333', fontSize: '15px',
  },
  subjectTime: { margin: 0, color: '#888', fontSize: '12px' },
  deleteBtn: {
    background: 'none', border: '1px solid #ddd',
    borderRadius: '8px', padding: '6px 10px',
    cursor: 'pointer', fontSize: '14px',
  },
  weeklyBox: {
    background: 'white', borderRadius: '16px',
    padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
  },
  weeklyTitle: {
    margin: '0 0 20px 0', fontSize: '15px',
    fontWeight: 'bold', color: '#333',
  },
  weeklyGrid: {
    display: 'flex', gap: '10px',
    alignItems: 'flex-end', justifyContent: 'space-around',
    height: '100px',
  },
  weeklyItem: {
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', gap: '5px',
    cursor: 'pointer', flex: 1,
  },
  weeklyDay: {
    margin: 0, fontSize: '11px',
    fontWeight: 'bold', color: '#888',
  },
  weeklyBar: {
    width: '100%', borderRadius: '4px',
    transition: 'height 0.3s',
  },
  weeklyCount: {
    margin: 0, fontSize: '11px', color: '#555',
  },
  modalOverlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.5)', zIndex: 1001,
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', padding: '20px',
  },
  modal: {
    background: 'white', borderRadius: '16px',
    padding: '30px', width: '100%', maxWidth: '420px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    maxHeight: '90vh', overflowY: 'auto',
  },
  modalTitle: {
    margin: '0 0 20px 0', fontSize: '18px',
    fontWeight: 'bold', color: '#333',
  },
  field: { marginBottom: '15px', flex: 1 },
  label: {
    display: 'block', fontSize: '13px',
    fontWeight: '600', color: '#444', marginBottom: '6px',
  },
  input: {
    width: '100%', padding: '11px 14px',
    borderRadius: '10px', border: '1.5px solid #ddd',
    fontSize: '14px', outline: 'none', boxSizing: 'border-box',
  },
  timeRow: { display: 'flex', gap: '12px' },
  modalButtons: { display: 'flex', gap: '12px', marginTop: '20px' },
  cancelBtn: {
    flex: 1, padding: '12px', background: 'white',
    color: '#666', border: '1.5px solid #ddd',
    borderRadius: '10px', cursor: 'pointer',
    fontWeight: 'bold', fontSize: '14px',
  },
  doneBtn: {
    flex: 1, padding: '12px',
    background: 'linear-gradient(135deg, #0f3460, #16213e)',
    color: 'white', border: 'none', borderRadius: '10px',
    cursor: 'pointer', fontWeight: 'bold', fontSize: '14px',
  },
};

export default MemberClassSchedule;